import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Typography } from '@material-ui/core';
import { useCallback, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import * as yup from 'yup';

import { Button } from '../../../../shared/components/Button';
import { Input } from '../../../../shared/components/Form/Input';
import { InputPassword } from '../../../../shared/components/Form/Input/InputPassword';
import { useAuth } from '../../../../shared/hooks/useAuth';
import { useSnackMessages } from '../../../../shared/hooks/useSnackMessages';
import { PageAnimation } from '../../components/Animation/PageAnimation';
import { Header } from '../../components/Header';

const schema = yup.object().shape({
  email: yup.string().required('O e-mail é obrigatório.'),
  password: yup
    .string()
    .required('A senha é obrigatória.')
    .min(6, 'No mínimo 6 caracteres.'),
});

type FormValues = {
  email: string;
  password: string;
};

function SignIn() {
  const { signIn } = useAuth();
  const { msgError } = useSnackMessages();
  const [loading, setLoading] = useState(false);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(schema),
    defaultValues: {
      email: '',
      password: '',
    },
    mode: 'onChange',
  });

  const onSubmit = useCallback(
    async ({ email, password }: FormValues) => {
      setLoading(true);

      try {
        await signIn({ email, password });
      } catch (err: any) {
        msgError(err?.message);
        setLoading(false);
      }
    },
    [signIn, msgError]
  );

  return (
    <PageAnimation>
      <Header title="Fazer login" mb={4} />

      <Box
        component="form"
        display="flex"
        flexDirection="column"
        gridGap={8}
        onSubmit={handleSubmit(onSubmit)}
      >
        <Input
          type="email"
          name="email"
          control={control}
          error={errors}
          variant="outlined"
          label="Insira seu e-mail"
          fullWidth
          required
          disabled={loading}
        />
        <InputPassword
          name="password"
          control={control}
          error={errors}
          variant="outlined"
          label="Digite sua senha"
          required
          disabled={loading}
        />

        <Box display="inline-flex" justifyContent="flex-end" my={1}>
          <Typography color="primary" component="div">
            <Link to="/forgot-password">
              <Box fontSize="14px">Esqueci minha senha</Box>
            </Link>
          </Typography>
        </Box>

        <Button
          type="submit"
          loading={loading}
          disabled={loading}
          style={{ width: '100%' }}
        >
          Entrar
        </Button>
      </Box>
    </PageAnimation>
  );
}

export { SignIn };
